module.exports = __webpack_public_path__ + "static/img/qrcode-wx.9330d436.jpg";